<template>
    <div class="row">
      <div class="col-md">
        <template v-if="'body' in news">
            <div v-if="news.body"
            class="m-0 p-3"
            v-html="news.body"
            ></div>
          </template>
      </div>
    </div>
  </template>
  
  <script>
    import pick from 'lodash/pick'
    import api from '@/api'
  
    export default {
      props: {
        news: {
          type: Object,
        },
      },
      computed: {
      },
      methods: {
      },
    }
  </script>
  
  <style lang="scss">
    @import "boot";
    .modem-command-data-result {
      background-color: $gray-200;
    }
  </style>
  


// WEBPACK FOOTER //
// resources/assets/js/components/news-list-details.vue